import { LaboratoryExamsCoverage } from '@/app/(main)/(pages)/(institucional)/(index)/laboratorios/_services/get-laboratory-exams-coverage.service';
import { PartnerExamsCoverage } from '@/app/(main)/_components/search-modal/search-modal.types';

export function buildLaboratoryExamsCoverage(
  laboratoryName: string,
  coverage: LaboratoryExamsCoverage,
): PartnerExamsCoverage {
  return {
    partnerName: laboratoryName,
    isFullCoverage: coverage.isFullCoverage,
    total: coverage.total,
    offeredProcedures: coverage.offered.map((exam) => ({
      id: exam.id,
      name: exam.name,
      price: exam.price,
    })),
    notOfferedProcedures: coverage.notOffered,
  };
}
